export default "__VITE_ASSET__BesG3eG0__"